/* eslint-disable */
import store from '@/store'
export default {
  data () {
    return {
    }
  },
  methods: {
    getData: function (path){
      return new Promise((resolve, reject) => {
        fetch(store.state.PROTOCOL + '://' + store.state.IP + ':' + store.state.API_PORT + path)
        //fetch(window.location.protocol + '//0.0.0.0:8080' + path)
        .then(function(response){
          // CHECK RESPONSE
          if (response.ok)
            return response.json()
          else
            throw response.ok
        })
        .then(function(response){
          // SUCCESS
          resolve(response)
        })
        .catch((error) => {
          // ERROR
          reject(new Error(error.message))
          console.warn('API call failed')
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/api-mixin.js